<template>
  <div class="ask-mod">
    <van-skeleton class="bg-white" v-if="loading" title avatar :row="10" />
    <template v-else>
      <div class="ask-wrap bg-white flex-x pd-a mg-b">
        <div class="mg-r">
          <div class="avatar usr-avatar flex-x fe-m fe-c">
            <van-icon name="manager" />
          </div>
          <!-- <van-image :src="sales.avatar" /> -->
        </div>
        <div class="fe-full txt-l">
          <div class="ask-name txt-d-blue txt-bold">
            {{ ask.name || '匿名用户' }}
          </div>
          <div class="ask-box pds-y">{{ ask.content }}</div>
          <div class="tips txt-d-orange" v-if="ask.status == 0">
            <van-icon name="underway" />
            尊敬的用户，该问题将由师傅人工解答，需要一点时间，您也可以添加师傅微信在线问。
          </div>
          <div class="ask-info pds-y pd-x flex-x fe-m">
            <div class="fe-full">
              <van-tag type="warning" plain>{{ ask.cate }}</van-tag>
              <van-tag :type="ask.status ? 'success' : 'danger'" plain>{{
                ask.status ? '已回答' : '未回答'
              }}</van-tag>
            </div>
            <van-button
              plain
              hairline
              :type="ask.digged ? 'warning' : 'default'"
              :icon="'good-job' + (ask.digged ? '' : '-o')"
              size="mini"
              @click="doGood(ask)"
              >赞({{ ask.good }})</van-button
            >
            <van-button
              plain
              hairline
              type="danger"
              icon="good-job"
              size="mini"
              v-if="ask.deleable"
              @click="doDelete"
              >删除</van-button
            >
            <van-button
              plain
              hairline
              type="primary"
              :icon="imgUrl + '/sxyc/tx_mozhai.jpg'"
              size="mini"
              @click="showDashi"
              >人工</van-button
            >
          </div>
        </div>
      </div>
      <!-- 回复列表 -->
      <div
        class="ask-reply flex-x bdr-b pd-a"
        v-for="(reply, ri) in ask.replys"
        :key="ri"
      >
        <div class="mg-r" v-if="!reply.sale_id">
          <div class="avatar usr-avatar flex-x fe-m fe-c">
            <van-icon name="manager" />
          </div>
          <!-- <van-image :src="sales.avatar" /> -->
        </div>
        <div class="fe-full" :class="reply.sale_id ? 'txt-r' : 'txt-l'">
          <div class="ask-name txt-d-blue txt-bold">
            {{ reply.name || '匿名用户' }}
          </div>
          <div class="ask-box pds-y">{{ reply.content }}</div>
        </div>
        <div class="mg-l" v-if="reply.sale_id">
          <van-image class="avatar" :src="ask.avatar || ''" :radius="5" />
        </div>
      </div>
      <!-- 回复 -->
      <van-form class="write-reply flex-x pd-a" @submit="onReply">
        <div class="mg-r mg-t">
          <div class="avatar usr-avatar flex-x fe-m fe-c">
            <van-icon name="manager" />
          </div>
          <!-- <van-image :src="sales.avatar" /> -->
        </div>
        <div
          class="fe-full text-area bg-white"
          :class="reply.sale_id ? 'txt-r' : 'txt-l'"
        >
          <van-field
            type="tel"
            maxlength="4"
            v-model="reply.code"
            :placeholder="'输入手机号后4位，' + ask.phone"
            :rules="[{ required: true, message: '请填写问题手机号后4位' }]"
          />
          <van-field
            type="textarea"
            maxlength="240"
            v-model="reply.content"
            placeholder="输入回复内容"
            :rules="[{ required: true, message: '请输入回复内容' }]"
          />
          <div class="flex-x">
            <small class="fe-full" style="color: #999"
              >还可以输入{{ replyLen }}个字</small
            >
            <van-button type="primary" size="mini" :loading="sendReply"
              >立即回复</van-button
            >
          </div>
        </div>
      </van-form>
      <!-- 私有：在线师傅 -->
      <dashi-box :show="dsShow" :saleid="ask.sellid"></dashi-box>
    </template>
  </div>
</template>

<script>
import { Form, Field } from 'vant'
import { mapState } from 'vuex'
import dashiBox from './dashi-box'
export default {
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    dashiBox
  },
  data() {
    return {
      loading: true,
      ask: null,
      sendReply: false,
      reply: {
        id: parseInt(this.$route.query.id),
        content: '',
        code: ''
      },
      dsShow: false
    }
  },
  computed: {
    ...mapState(['imgUrl']),
    replyLen() {
      return 240 - this.reply.content.length
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    showDashi() {
      //this.$store.commit('setDsShow', true)
      this.dsShow = true
    },
    loadData() {
      this.$axios
        .get('crm/forum/read', { params: { id: this.$route.query.id } })
        .then((res) => {
          this.loading = false
          this.ask = res.data || {}
          //设置sellid为当前
          if (this.ask.sellid) {
            //this.$store.commit('setSellid', this.ask.sellid)
          }
        })
    },
    onReply() {
      let prms = this.reply
      this.sendReply = true
      this.$axios
        .post('/crm/forum/reply', prms)
        .then((res) => {
          this.sendReply = false
          console.log(res)
          this.ask.replys.push(res.data)
          //location.reload()
        })
        .catch(() => {
          this.sendReply = false
        })
    },
    doGood() {
      let ask = this.ask
      let params = { id: ask.id, action: 'good' }
      this.$axios.get('/crm/forum/digg', { params }).then((res) => {
        this.$set(this.ask, 'good', res.data.good)
        this.$set(this.ask, 'digged', 1)
      })
    },
    doDelete() {
      let ask = this.ask
      let params = { id: ask.id }
      this.$axios.get('/crm/forum/delete', { params }).then(() => {
        this.$router.replace('/forum')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ask-mod {
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 5px;
    color: #fff;
    font-size: 1.5em;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  }
  .usr-avatar {
    background: #1cbbb4;
  }
}
.ask-info {
  background-color: #eee;
  border-radius: 3px;
  .van-tag {
    margin-right: 5px;
  }
}
.bdr-b {
  border-bottom: #eee solid 1px;
}
.text-area {
  border-radius: 5px;
  border: #eee solid 1px;
  padding: 5px;
  .van-field {
    padding: 5px;
    margin-bottom: 3px;
  }
}
.text-area /deep/ .van-field__error-message {
  color: rgb(255, 145, 0);
}
.tips {
  font-size: 0.8em;
  padding: 8px;
  color: #e9561d;
  border: #f19f34 solid 1px;
  margin: 5px 0;
  border-radius: 5px;
}
</style>